import {ViewType} from 'brandConstants';
import {ProductItem} from 'coreStore/data/basket/types';
import {IProductPriceObject} from 'coreClasses/product/IProduct';
import VariantModel from 'coreClasses/product/VariantModel';

/**
 * Represents CartProductItemModel
 */
export default class CartProductItemModel {
	public brand: string;
	public category: string;
	public color: string;
	public image: string;
	public master_id: string;
	public name: string;
	public price: number | IProductPriceObject;
	public quantity: number;
	public size: string;
	public url: string;
	public variant_id: string;

	/**
	 * @constructor
	 * @param {ProductItem} productItem - product item
	 * @param {VariantModel} product
	 */
	constructor(productItem: ProductItem, product: VariantModel) {
		if (!product || !productItem) {
			return;
		}

		this.variant_id = productItem.productId;
		this.quantity = productItem.quantity;
		this.price = productItem.priceAfterItemDiscount || product.getPriceModel().getMinPrice().value;

		this.master_id = productItem?.c_variationGroupId;
		this.name = product.getName();
		this.brand = product.getBrand();
		this.size = product.getSize();
		this.color = product.getColorDescription();
		this.url = product.getProductUrl();
		this.image = product
			.getProductImage({
				viewType: ViewType.ZOOM,
				index: 0,
			})
			?.getUrl();
		this.category = product.getCategoryId();
	}
}
